import { styled } from 'styled-components';

export const Logo4pl = styled.img`
  height: 45px;
  margin-left: 10px;
`;
